module.exports = __webpack_public_path__ + "img/dog-walking.4d18a126.jpg";